import axios from "axios";
import AuthenticationFailureHandler from "../utils/AuthenticationFailureHandler";
import { ONBOARDING_BASE_URL } from "../utils/EmpUtil";
import { is401, is404 } from "../errors/ErrorConstants";

const DEALER_TERMS_PATH = "/documents/dealer-terms-conditions";

class OnboardingDocumentsClient {
  /**
   * @param {"FORD"|"LINCOLN"|"DUAL"} termsType
   */
  static getDealerTermsPdf(termsType) {
    const url = `${ONBOARDING_BASE_URL}${DEALER_TERMS_PATH}`;
    return axios
      .get(url, {
        params: { termsType },
        responseType: "blob",
      })
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error) || is404(error)) {
          AuthenticationFailureHandler.execute();
        }
        throw error;
      });
  }
}

export default OnboardingDocumentsClient;
